import React, { Component } from "react";
import {
  Nav,
  TabsCustom,
  TabsCustomHeader,
  TabsCustomMenu,
  TabsCustomBody,
  TabsCustomItem,
  Loader,
  FormRadio,
  FormInput,
  Button,
} from "ui-kit-ck-consultant";
import FadeIn from "react-fade-in";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import ShowOptionsNGRA from "../../../components/general/ShowOptionsNGRA-v2";
import GeneralData from "../../../components/company/performance/GeneralData";
import PrintClass from "../../../components/general/Print";
import CardCompany from "../../../components/company/performance/card-company/CardCompany";

import "../../../style/companyPerformance.css";

import axiosConfig from "../../../utils/axiosConfig";
import { alertError } from "../../../utils/errorMessage";

import AuthContext from "../../../context/AuthContext";
import filterStore from "../../../stores/filterStore";

export default class CompanyPerformance extends Component {
  constructor(props) {
    super(props);
    const saved = filterStore.getState().getPageState("companyPerformance");
    this.state = saved || {
      // Loader state
      isLoad: false,
      // ShowOption state
      year: 0,
      network: 0,
      group: 0,
      region: 0,
      agency: [],
      company: 0,
      user: 0,
      filter: "1",
      kind: [],
      agencyDepartment: 0,
      // Data state
      performanceAgency: {},
      VTHG: 0,
      data: null,
      dataChart: null,
      dataOpenDescriptifState: [],
      dataOpenMarketSearch: [],
      // Tabs state
      tabsData: [],
      tabsMenu: [],
      tabsIndex: 0,
      companyLogo: null,
      tabsIndexGeneral: 0,
      dbType: "1",
      darvaCode: "",
    };

    this.refPrintGlobal = React.createRef();
  }

  componentWillUnmount() {
    filterStore.getState().setPageState("companyPerformance", this.state);
  }

  static contextType = AuthContext;

  handleRadioChange = (e) => {
    let { name, value } = e.target;
    this.setState(
      {
        [name]: value,
      },
      this.getGeneralData,
    );
  };

  handleDataChange = (data) => {
    filterStore.getState().setPageFilters("companyPerformance", data);
    this.setState(
      {
        year: data.year,
        network: data.network,
        group: data.group,
        region:
          data.regionMultiples && data.regionMultiples.length
            ? [...data.regionMultiples]
            : data.region,
        agency: [...data.agencyMultiples],
        company: data.company,
        user: data.user,
        dateStart: data.dateStart,
        dateEnd: data.dateEnd,
        kind: data.kind,
      },
      () => {
        if (
          [1, 2, 5, 7, 8, 9, 10, 11, 13, 16, 20, 29, 38, 40].includes(
            parseInt(this.state.company),
          )
        ) {
          const tabs = ["Général", "Spécifique"];
          const tabsData = ["Data Général", "Data Spécifique"];
          this.setState(
            {
              tabsMenu: tabs,
              tabsData: tabsData,
            },
            () => {
              if (this.state.tabsIndex === 0) {
                this.getGeneralData();
              }
            },
          );
        } else {
          this.setState(
            {
              tabsMenu: ["Général"],
              tabsData: ["Data Général"],
              tabsIndex: 0,
            },
            () => {
              if (this.state.tabsIndex === 0) {
                this.getGeneralData();
              }
            },
          );
        }
      },
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.company !== this.state.company && this.state.company !== 0) {
      this.getCompanyLogo();
    }
  }

  getCompanyLogo = () => {
    axiosConfig("/company-performance/get-company-logo", {
      data: {
        id: this.state.company,
      },
    }).then((res, err) => {
      if (res && res.data.logo) {
        const companyLogo = res.data.logo;
        this.setState({ companyLogo });
      } else {
        this.setState({ companyLogo: null });
      }
    });
  };

  updatePerformanceAgency = () => {
    axiosConfig("/company-performance/update-performance-agency", {
      data: {
        agency: this.state.agency,
        performanceAgency: this.state.performanceAgency,
      },
    }).then((res, err) => {});
  };

  getGeneralData = () => {
    this.setState({ isLoad: true, data: null, dataChart: null }, () => {
      axiosConfig("/company-performance/get-general-data", {
        data: {
          dateStart: this.state.dateStart,
          dateEnd: this.state.dateEnd,
          network: this.state.network,
          group: this.state.group,
          region: this.state.region,
          agency: this.state.agency,
          company: this.state.company,
          type: this.state.tabsIndex,
          user: this.state.user,
          userType: this.context.type === 5 ? [5] : [2, 3],
          filter: this.state.filter,
          kind: this.state.kind,
          agencyDepartment: this.state.agencyDepartment,
          VTHG: this.state.VTHG,
          dbType: this.state.dbType,
          darvaCode: this.state.darvaCode,
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              performanceAgency: res.data.performanceAgency,
              data: res.data.dataGeneral,
              dataChart: res.data.dataChart,
              dataByExpert: res.data.dataByExpert || [],
              dataByAgency: res.data.dataByAgency || [],
              dataOpenDescriptifState: res.data.dataOpenDescriptifState,
              dataOpenMarketSearch: res.data.dataOpenMarketSearch,
              isLoad: false,
            });
          } else {
            this.setState({
              isLoad: false,
            });
          }
        })
        .catch((err) => {
          this.setState({ isLoad: false });
          alertError(err);
        });
    });
  };

  render() {
    return (
      <>
        <FadeIn>
          <div ref={this.refPrintGlobal}>
            <Nav
              className="mb-10 mb-20-xl nowrap"
              title="Performance compagnie"
            >
              {this.state.companyLogo ? (
                <img
                  className="imageCompany"
                  src={this.state.companyLogo}
                  alt="logo-company"
                />
              ) : null}
            </Nav>
            <ShowOptionsNGRA
              isKind
              defaultKind={["VP", "CTTE"]}
              isChange={true}
              className="mb-10 mb-20-xl"
              onDataChange={this.handleDataChange}
              initialFilters={filterStore
                .getState()
                .getPageFilters("companyPerformance")}
              isCompany={true}
              isUser={true}
              isDateStart={true}
              isDateEnd={true}
              isAll={true}
              isRegionMultiples={true}
              isAgencyMultiples={true}
              visibilityRole={this.props.visibilityRole}
              visibilityType={this.props.visibilityType}
              preloadRole={this.props.preloadRole}
              preloadType={this.props.preloadType}
              limitUserType={this.props.limitUserType}
              limitUserRole={this.props.limitUserRole}
              allUserRole={this.props.allUserRole}
              userType={this.context.type === 5 ? [5] : [2, 3]}
              others={
                <>
                  {this.state.company === 3 ? (
                    <div
                      className="d-flex"
                      style={{ alignItems: "center", gap: 10 }}
                    >
                      <p>Périmètre</p>
                      <FormRadio
                        className="mr-10"
                        name="filter"
                        value={"1"}
                        checked={this.state.filter === "1"}
                        onChange={this.handleRadioChange}
                        text="R 21 - 4000 / NR : 100 - 12 000"
                      />
                      <FormRadio
                        className="mr-10"
                        name="filter"
                        value={"2"}
                        checked={this.state.filter === "2"}
                        onChange={this.handleRadioChange}
                        text="R 21 - 35000 / NR : 0 - 35000"
                      />
                    </div>
                  ) : null}
                  {this.state.company === 2 ? (
                    <div
                      className="d-flex"
                      style={{ alignItems: "center", gap: 10 }}
                    >
                      <p>Périmètre</p>
                      <FormRadio
                        className="mr-10"
                        name="filter"
                        value={"1"}
                        checked={this.state.filter === "1"}
                        onChange={this.handleRadioChange}
                        text="R pas de filtre "
                      />
                      <FormRadio
                        className="mr-10"
                        name="filter"
                        value={"2"}
                        checked={this.state.filter === "2"}
                        onChange={this.handleRadioChange}
                        text="R 0 - 3 500 € HT"
                      />
                      <FormRadio
                        className="mr-10"
                        name="filter"
                        value={"3"}
                        checked={this.state.filter === "3"}
                        onChange={this.handleRadioChange}
                        text="R 0 - 10 000 € HT / NR 0 - 15 000 € TTC"
                      />
                    </div>
                  ) : null}
                  {this.state.company === 8 ? (
                    <div
                      className="d-flex"
                      style={{ alignItems: "center", gap: 10 }}
                    >
                      <p>Périmètre</p>
                      <FormRadio
                        className="mr-10"
                        name="filter"
                        value={"1"}
                        checked={this.state.filter === "1"}
                        onChange={this.handleRadioChange}
                        text="Défaut"
                      />
                      <FormRadio
                        className="mr-10"
                        name="filter"
                        value={"2"}
                        checked={this.state.filter === "2"}
                        onChange={this.handleRadioChange}
                        text="R tranche de coût 250 € - 3000 € HT / NR >= 10 ans et dans la tranche 2 € à 8000 € TTC"
                      />
                    </div>
                  ) : null}
                  {this.state.company === 1 ? (
                    <div
                      className="d-flex"
                      style={{ alignItems: "center", gap: 10 }}
                    >
                      <p>Périmètre</p>
                      <FormRadio
                        className="mr-10"
                        name="agencyDepartment"
                        value={""}
                        checked={!this.state.agencyDepartment}
                        onChange={this.handleRadioChange}
                        text="Rapprochement agence standard"
                      />
                      <FormRadio
                        className="mr-10"
                        name="agencyDepartment"
                        value={"1"}
                        checked={this.state.agencyDepartment}
                        onChange={this.handleRadioChange}
                        text="Rapprochement agence standard + SOLUTION EAD NATIONAL"
                      />
                    </div>
                  ) : null}
                  {this.state.company === 20 ? (
                    <div
                      className="d-flex"
                      style={{ alignItems: "center", gap: 10 }}
                    >
                      <p>VTHG</p>
                      <FormRadio
                        className="mr-10"
                        name="VTHG"
                        value={"0"}
                        checked={!this.state.VTHG}
                        onChange={this.handleRadioChange}
                        text="Non filtré"
                      />
                      <FormRadio
                        className="mr-10"
                        name="VTHG"
                        value={"1"}
                        checked={this.state.VTHG === "1"}
                        onChange={this.handleRadioChange}
                        text="Oui"
                      />
                      <FormRadio
                        className="mr-10"
                        name="VTHG"
                        value={"2"}
                        checked={this.state.VTHG === "2"}
                        onChange={this.handleRadioChange}
                        text="Non"
                      />
                    </div>
                  ) : null}
                  <div
                    className="d-flex"
                    style={{ alignItems: "center", gap: 10 }}
                  >
                    <p>N° DARVA</p>
                    <FormInput
                      className="mr-10"
                      name="darvaCode"
                      value={this.state.darvaCode}
                      placeholder="Recherche par N° DARVA"
                      onChange={(e) =>
                        this.setState({ darvaCode: e.target.value })
                      }
                    />
                  </div>
                  <div
                    className="d-flex"
                    style={{ alignItems: "center", gap: 10 }}
                  >
                    <p>Base de données</p>
                    <FormRadio
                      className="mr-10"
                      name="dbType"
                      value={"1"}
                      checked={this.state.dbType === "1"}
                      onChange={this.handleRadioChange}
                      text="Alpha Expert"
                    />
                    <FormRadio
                      className="mr-10"
                      name="dbType"
                      value={"2"}
                      checked={this.state.dbType === "2"}
                      onChange={this.handleRadioChange}
                      text="Darva"
                    />
                  </div>
                  <Button
                    disabled={!this.state.data}
                    className="w-auto"
                    text="Télécharger CSV"
                    onClick={() => {
                      (() => {
                        const element = document.createElement("a");
                        // eslint-disable-next-line no-undef
                        const file = new Blob([this.state.data.dataR_CSV], {
                          type: "text/csv;charset=utf-8",
                        });
                        element.href = URL.createObjectURL(file);
                        element.download = "extract_R.csv";
                        document.body.appendChild(element);
                        element.click();
                      })();

                      (() => {
                        const element = document.createElement("a");
                        // eslint-disable-next-line no-undef
                        const file = new Blob([this.state.data.dataNR_CSV], {
                          type: "text/csv;charset=utf-8",
                        });
                        element.href = URL.createObjectURL(file);
                        element.download = "extract_NR.csv";
                        document.body.appendChild(element);
                        element.click();
                      })();
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                  </Button>
                </>
              }
            />
            {this.state.tabsData.length > 0 ? (
              <TabsCustom>
                <TabsCustomHeader>
                  {this.state.tabsMenu.map((element, idx) => (
                    <TabsCustomMenu
                      key={idx}
                      title={element}
                      active={this.state.tabsIndex === idx}
                      disabled={!this.state.tabsData[idx]}
                      onClick={(e) => {
                        if (this.state.tabsIndex !== idx) {
                          this.state.tabsData[idx] &&
                            this.setState({ tabsIndex: idx }, () => {
                              if (this.state.tabsIndex === 0) {
                                this.getGeneralData();
                              }
                            });
                        }
                      }}
                    />
                  ))}
                </TabsCustomHeader>
                <TabsCustomBody noCard>
                  {this.state.tabsMenu.map((element, idx) => (
                    <TabsCustomItem
                      key={idx}
                      active={this.state.tabsIndex === idx}
                    >
                      {idx === 0 ? (
                        this.state.data && this.state.dataChart ? (
                          <GeneralData
                            leaveUpdatePerformanceAgency={() =>
                              this.updatePerformanceAgency()
                            }
                            updatePerformanceAgency={(name, value) => {
                              let tmpData = JSON.parse(
                                JSON.stringify(this.state.performanceAgency),
                              );

                              tmpData[name] = value;

                              this.setState({
                                performanceAgency: tmpData,
                              });
                            }}
                            performanceAgency={this.state.performanceAgency}
                            network={this.state.network}
                            group={this.state.group}
                            region={this.state.region}
                            agency={this.state.agency}
                            user={this.state.user}
                            company={this.state.company}
                            data={this.state.data}
                            dataChart={this.state.dataChart}
                            dataByExpert={this.state.dataByExpert}
                            dataByAgency={this.state.dataByAgency}
                            dataOpenDescriptifState={
                              this.state.dataOpenDescriptifState
                            }
                            dataOpenMarketSearch={
                              this.state.dataOpenMarketSearch
                            }
                            isPrint={this.state.isPrint}
                            tabsIndex={this.state.tabsIndexGeneral}
                            onChangeTab={(idx) =>
                              this.setState({ tabsIndexGeneral: idx })
                            }
                            onLabelsLoaded={(isLoad) =>
                              this.setState({ isLoad })
                            }
                          />
                        ) : null
                      ) : (
                        <>
                          {this.state.tabsIndex === 1 ? (
                            <CardCompany
                              company={this.state.company}
                              data={{
                                network: this.state.network,
                                group: this.state.group,
                                region: this.state.region,
                                agency: this.state.agency,
                                user: this.state.user,
                                company: this.state.company,
                                dateStart: this.state.dateStart,
                                dateEnd: this.state.dateEnd,
                                filter: this.state.filter,
                                darvaCode: this.state.darvaCode,
                              }}
                              year={Number(this.state.year)}
                              isPrint={this.state.isPrint}
                            />
                          ) : null}
                        </>
                      )}
                    </TabsCustomItem>
                  ))}
                </TabsCustomBody>
              </TabsCustom>
            ) : null}
          </div>
        </FadeIn>
        <Loader show={this.state.isLoad} />
        <PrintClass
          refs={
            this.state.isPrint && this.state.isLoad ? [this.refPrintGlobal] : []
          }
          title={"Performances Compagnie"}
          fileName={"Performances Compagnie"}
          onPrint={(print) => this.setState({ isPrint: print, isLoad: print })}
          width={1000}
        />
      </>
    );
  }
}
